module.exports = __webpack_public_path__ + "img/backBanner.c36c61d.png";